import * as angular from 'angular';
export class ibGreyBarTransformer {
    constructor (
        private $window: ng.IWindowService,
        private NewMainHeaderConstants: ibPlusConstantNamespace.NewMainHeaderConstants,
        private CommonsUserUtilsService: CommonsUserUtilsService
    ) { }

    initGreyBar (model) {
        let greyBarModel = undefined;

        if(model) {
            greyBarModel={
                login: {onLogin : model.onLogin || this.$window.location.reload, afterLogin : model.afterLogin || this.$window.location.reload, onError: model.onError || this.$window.location.reload},
                loggedData:{},
                userLogged: model.userLogged,
                isONB: model.userLogged === this.NewMainHeaderConstants.LOGIN_TYPES.ONB
            };

            if(model.loggedData) {
                greyBarModel.isLogged = true;
                greyBarModel.loggedData= this.updateLoggedData(model.loggedData);

            }else{
                greyBarModel.isLogged = false;
            }
            greyBarModel.show = model.show  === true || model.show === false ? model.show : true;
        }

        return greyBarModel;
    }

    transformAvios (avios) {
        return avios.toString();
    }

    updateLoggedData (customerData) {
        let loggedData;
        const isIbZero = this.CommonsUserUtilsService.isIbZero();
        const isSoftUser = this.CommonsUserUtilsService.isSoftUser();
        if(customerData.personalInfo) {
            if((customerData.generalInfo.avios || customerData.generalInfo.avios === 0) && !customerData.generalInfo.aviosTransformed) {
                customerData.generalInfo.aviosTransformed = this.transformAvios(customerData.generalInfo?.avios);
            }
            loggedData ={
                name: customerData.personalInfo.name || customerData.personalInfo.contactEmail,
                surname:!isSoftUser ? customerData.personalInfo.surname1 : null,
                avios: !isIbZero ? customerData.generalInfo.aviosTransformed : null,
                isLogged: true
            };
        }else{
            loggedData ={
                name: customerData.userInfo.firstName,
                surname: !isSoftUser ? customerData.userInfo.lastName : null,
                points: customerData.pointsTransformed,
                isLogged: true
            };
        }
        return loggedData;
    }

}
ibGreyBarTransformer.$inject = ['$window', 'NewMainHeaderConstants', 'CommonsUserUtilsService'];
try {
    const mod = angular.module('ib-grey-bar-module');
    mod.service(
        'ibGreyBarTransformer',
        ibGreyBarTransformer
    );
} catch (error) {
    const mod = angular.module('ib-grey-bar-module');
    mod.service(
        'ibGreyBarTransformer',
        ibGreyBarTransformer
    );
}
